import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { useTrackInfo } from '@hooks/useTrackInfo';
import { UnassociatedVideoDetails } from '@components/shared/UnassociatedVideoDetails/UnassociatedVideoDetails';

const Container = styled.div`
  height: 495px;
`;

type UnassociatedVideosExpandedRowProps = {
  albumUri: string;
  trackUri: string;
};

export const UnassociatedVideosExpandedRow: FunctionComponent<
  UnassociatedVideosExpandedRowProps
> = ({ albumUri, trackUri }) => {
  const { data: trackInfo } = useTrackInfo(
    typeof albumUri === 'string' ? albumUri : '',
    typeof trackUri === 'string' ? trackUri : '',
  );

  return (
    <Container>
      {!!trackInfo && (
        <UnassociatedVideoDetails
          associatedTrack={trackInfo.effectiveData.associatedTrack}
          isrc={trackInfo.effectiveData.isrc}
          identifiers={trackInfo.effectiveData.identifiers}
          metadata={{
            name: trackInfo.effectiveData.name,
            artists: trackInfo.effectiveData.artists,
            explicitLyrics: trackInfo.effectiveData.explicitLyrics,
            uri: trackInfo.effectiveData.uri,
            mediaType: trackInfo.effectiveData.mediaType,
            duration: trackInfo.effectiveData.duration,
          }}
        />
      )}
    </Container>
  );
};
